import { ModelEntityType } from '@upright/common/model/input/types';
import { GenericEmptyState } from '@upright/ui/common/upright/core/impact-lens-profile/common/components/empty-states/generic-empty-state';
import { useCarouselContext } from '@upright/ui/common/upright/core/impact-lens-profile/context';

export function SdgsLensEmptyState() {
  // The lens also renders a product's own alignments on the unified product profile.
  const isProduct = useCarouselContext().data.entity?.type === ModelEntityType.PRODUCT;
  return (
    <GenericEmptyState
      dataTitle="UN Sustainable Development Goals alignment data"
      noDataMessage={`No data on the alignment of this ${isProduct ? 'product' : 'company'} with UN Sustainable development goals is currently available`}
    />
  );
}
